var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2053_55)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.228516,
    y: 0.417969,
    width: 52.3286,
    height: 52.3286,
    rx: 26.1643,
    fill: "#A7E7B5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9268,
    y: 9.1394,
    width: 20.9314,
    height: 20.9314,
    rx: 10.4657,
    fill: "#7B61FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12.8535,
    y: 35.3037,
    width: 78.4929,
    height: 78.4929,
    rx: 39.2465,
    fill: "#7B61FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2053_55"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.228516,
    y: 0.417969,
    width: 52.3286,
    height: 52.3286,
    rx: 26.1643,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar5);
export default __webpack_public_path__ + "static/media/avatar5.f709a2b710393cb04760c607b9418c3b.svg";
export { ForwardRef as ReactComponent };